module.exports = __webpack_public_path__ + "static/media/shawl.3d916dfa.svg";